export class ErrorOAuth2 {
}
export class ErrorUnknown extends ErrorOAuth2 {
    constructor(message) {
        super();
        this.message = message;
    }
}
export class ErrorNoAccessToken extends ErrorOAuth2 {
}
export class ErrorNoAuthCode extends ErrorOAuth2 {
}
export class ErrorInvalidReturnedStateParam extends ErrorOAuth2 {
}
export class ErrorInvalidScope extends ErrorOAuth2 {
}
export class ErrorInvalidRequest extends ErrorOAuth2 {
}
export class ErrorInvalidToken extends ErrorOAuth2 {
}
export class ErrorAuthenticationGrant extends ErrorOAuth2 {
}
export class ErrorUnauthorizedClient extends ErrorAuthenticationGrant {
}
export class ErrorAccessDenied extends ErrorAuthenticationGrant {
}
export class ErrorUnsupportedResponseType extends ErrorAuthenticationGrant {
}
export class ErrorServerError extends ErrorAuthenticationGrant {
}
export class ErrorTemporarilyUnavailable extends ErrorAuthenticationGrant {
}
export class ErrorAccessTokenResponse extends ErrorOAuth2 {
}
export class ErrorInvalidClient extends ErrorAccessTokenResponse {
}
export class ErrorInvalidGrant extends ErrorAccessTokenResponse {
}
export class ErrorUnsupportedGrantType extends ErrorAccessTokenResponse {
}
export const RAW_ERROR_TO_ERROR_CLASS_MAP = {
    invalid_request: ErrorInvalidRequest,
    invalid_grant: ErrorInvalidGrant,
    unauthorized_client: ErrorUnauthorizedClient,
    access_denied: ErrorAccessDenied,
    unsupported_response_type: ErrorUnsupportedResponseType,
    invalid_scope: ErrorInvalidScope,
    server_error: ErrorServerError,
    temporarily_unavailable: ErrorTemporarilyUnavailable,
    invalid_client: ErrorInvalidClient,
    unsupported_grant_type: ErrorUnsupportedGrantType,
    invalid_token: ErrorInvalidToken,
};
export const toErrorObject = (rawError) => {
    const errorClass = RAW_ERROR_TO_ERROR_CLASS_MAP[rawError];
    return errorClass ? new errorClass() : new ErrorUnknown(rawError);
};
export class ErrorWWWAuthenticate {
    constructor() {
        this.realm = '';
        this.error = '';
    }
}
